<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<action-buttons :scrId="scrId" @openUbiReport="openUbiReport"></action-buttons>

			<!-- 기본정보 Form 시작 -->
			<div class="sf-card__header mt-3">
				<div class="d-flex align-items-end">
					<!-- 기본정보 -->
					<span class="title"><i class="sf-icon icon-sf-caret-right" />{{ getMessage_('QWCC001343') }}</span>
				</div>
			</div>

			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
							<!-- 관리번호  -->
							<th class="col-1">{{ getMessage_('QWCC001317') }}</th>
							<td class="col-1">
								<el-input :value="popupData.mesEqipNo" @input="value => onChangeParam({ key: 'mesEqipNo', value })" readOnly />
							</td>
							<!-- 도입일자 -->
							<th class="col-1">* {{ getMessage_('QWCC001322') }}</th>
							<td class="col-1">
								<el-date-picker
									:value="popupData.puchDd?.replaceAll('-', '')"
									type="date"
									:readonly="isFlagYn"
									format="yyyy-MM-dd"
									value-format="yyyyMMdd"
									@input="value => onChangeParam({ key: 'puchDd', value })"
								/>
							</td>
							<!-- 사용부서 -->
							<th class="col-1">* {{ getMessage_('QWCC001321') }}</th>
							<td class="col-1">
								<el-input
									:value="popupData.useDeptNm"
									@input="value => onChangeParam({ key: 'useDeptNm', value })"
									@keyup.native.delete="() => onDeptInPutKeyDown()"
									:placeholder="getMessage_('QWCC001656')"
									readonly
								/>
								<span class="unit input-icon" v-show="!isFlagYn">
									<i class="icon-sf-search search-icon unit" @click="onDeptSearchPopup"></i>
								</span>
							</td>
							<!-- 담당자 -->
							<th class="col-1">* {{ getMessage_('QWCC000982') }}</th>
							<td class="col-1">
								<el-input
									:value="popupData.user1Nm"
									@input="value => onChangeParam({ key: 'user1Nm', value })"
									class="inputWithIcon"
									@keyup.native.delete="() => onUserInPutKeyDown('user1')"
									:placeholder="getMessage_('QWCC001656')"
									readonly
								></el-input>
								<span class="unit input-icon" v-show="!isFlagYn">
									<i class="icon-sf-search search-icon" @click="() => onUserSearchPopup('user1')"></i>
								</span>
							</td>
						</tr>
						<tr>
							<!-- 장비명(영문) -->
							<th>* {{ getMessage_('QWCC001335') }}</th>
							<td>
								<el-input
									:value="popupData.enMesEqipNm"
									@input="value => onChangeParam({ key: 'enMesEqipNm', value })"
									:readonly="isFlagYn"
								/>
							</td>
							<!-- 제조사 -->
							<th>{{ getMessage_('QWCC001318') }}</th>
							<td>
								<el-input :value="popupData.mkrNm" @input="value => onChangeParam({ key: 'mkrNm', value })" :readonly="isFlagYn" />
							</td>
							<!-- 사용장소 -->
							<th class="col-1">{{ getMessage_('QWCC001340') }}</th>
							<td class="col-1">
								<sf-select-group
									labelPosition="left"
									:inputValue="popupData.usePlCd"
									:disabled="isFlagYn"
									:options="usePlCdList"
									:onChange="value => onChangeParam({ key: 'usePlCd', value })"
								/>
							</td>
							<!-- 부서장 -->
							<th>* {{ getMessage_('QWCC001847') }}</th>
							<td class="col-1">
								<el-input
									:value="popupData.user2Nm"
									class="inputWithIcon"
									@input="value => onChangeParam({ key: 'user2Nm', value })"
									@keyup.native.delete="() => onUserInPutKeyDown('user2')"
									:placeholder="getMessage_('QWCC001656')"
									readonly
								></el-input>
								<span class="unit input-icon" v-show="!isFlagYn">
									<i class="icon-sf-search search-icon" @click="() => onUserSearchPopup('user2')"></i>
								</span>
							</td>
						</tr>
						<tr>
							<!-- 장비명(중문) -->
							<th>* {{ getMessage_('QWCC001336') }}</th>
							<td>
								<el-input
									:value="popupData.chMesEqipNm"
									@input="value => onChangeParam({ key: 'chMesEqipNm', value })"
									:readonly="isFlagYn"
								/>
							</td>
							<!-- 모델명 -->
							<th>* {{ getMessage_('QWCC001319') }}</th>
							<td>
								<el-input :value="popupData.mdlNm" @input="value => onChangeParam({ key: 'mdlNm', value })" :readonly="isFlagYn" />
							</td>
							<!-- 교정주기 -->
							<th class="col-1">{{ !eqipKndDisabled_ ? '* ' : '' }}{{ getMessage_('QWCC001323') }}</th>
							<td class="col-1">
								<sf-select-group
									labelPosition="left"
									:inputValue="popupData.calCyclCd"
									:options="calCyclCdList"
									:onChange="value => onChangeParam({ key: 'calCyclCd', value })"
									:disabled="eqipKndDisabled_ || isFlagYn"
								/>
							</td>
							<!-- 장비종류 -->
							<th>* {{ getMessage_('QWCC001337') }}</th>
							<td>
								<sf-select-group
									labelPosition="left"
									:inputValue="popupData.eqipKndCd"
									:disabled="isFlagYn"
									:options="eqipKndCdList"
									:onChange="value => onChangeParam({ key: 'eqipKndCd', value })"
								/>
							</td>
						</tr>
						<tr>
							<!-- 장비명(한글) -->
							<th>{{ getMessage_('QWCC002023') }}</th>
							<td>
								<el-input
									:value="popupData.koMesEqipNm"
									@input="value => onChangeParam({ key: 'koMesEqipNm', value })"
									:readonly="isFlagYn"
								/>
							</td>
							<!-- 시리얼번호 -->
							<th>{{ getMessage_('QWCC001320') }}</th>
							<td>
								<el-input
									:value="popupData.eqipSn"
									@input="value => onChangeParam({ key: 'eqipSn', value })"
									:readonly="isFlagYn"
									maxlength="20"
								/>
							</td>
							<!-- 교정보고서 유무-->
							<th>{{ getMessage_('QWCC001338') }}</th>
							<td>
								<sf-select-group
									labelPosition="left"
									:inputValue="popupData.calWrptYn"
									:options="ynCdList"
									:onChange="value => onChangeParam({ key: 'calWrptYn', value })"
									:disabled="isFlagYn"
								/>
							</td>
							<!-- 사양(SPEC) : 장비(S)면 필수-->
							<th>{{ eqipKndDisabled_ ? '* ' : '' }}{{ getMessage_('QWCC001908') }}</th>
							<td>
								<el-input :value="popupData.spcVal" @input="value => input({ key: 'spcVal', value })" :readonly="isFlagYn" />
							</td>
							<!-- 장비상세
							<th>* {{ getMessage_('QWCC001339') }}</th>
							<td>
								<sf-select-group
									labelPosition="left"
									:inputValue="popupData.eqipDtlCd"
									:disabled="isFlagYn"
									:options="eqipDtlCdList"
									:onChange="value => onChangeParam({ key: 'eqipDtlCd', value })"
								/>
							</td> -->
						</tr>
						<tr>
							<!-- 측정범위 -->
							<th>{{ getMessage_('QWCC001349') }}</th>
							<td colspan="2">
								<!-- <el-input
									:value="Number(popupData.mesScpMinVal)"
									@input="value => input({ key: 'mesScpMinVal', value })"
									style="width: 50% !important"
									placeholder="Min"
									:readonly="isFlagYn"
								/> -->
								<el-input
									:value="popupData.mesScpMinVal"
									@input="value => input({ key: 'mesScpMinVal', value })"
									style="width: 50% !important"
									placeholder="Min"
									:readonly="isFlagYn"
								/>
								<el-input
									:value="popupData.mesScpMaxVal"
									@input="value => input({ key: 'mesScpMaxVal', value })"
									style="width: 50% !important"
									placeholder="Max"
									:readonly="isFlagYn"
								/>
							</td>
							<td>
								<sf-select-group
									labelPosition="left"
									:inputValue="popupData.mesUtmCd"
									:options="utmCdList"
									:onChange="value => onChangeParam({ key: 'mesUtmCd', value })"
									:placeholder="getMessage_('QWCC001909')"
									:disabled="isFlagYn"
								/>
							</td>
							<!-- 정밀도 -->
							<th>{{ getMessage_('QWCC001350') }}</th>
							<td colspan="2">
								<el-input
									:value="popupData.lodeMinVal"
									@input="value => input({ key: 'lodeMinVal', value })"
									style="width: 50% !important"
									placeholder="Min"
									:readonly="isFlagYn"
								/>
								<el-input
									:value="popupData.lodeMaxVal"
									@input="value => input({ key: 'lodeMaxVal', value })"
									style="width: 50% !important"
									placeholder="Max"
									:readonly="isFlagYn"
								/>
							</td>
							<td>
								<sf-select-group
									labelPosition="left"
									:inputValue="popupData.lodeUtmCd"
									:options="utmCdList"
									:placeholder="getMessage_('QWCC001910')"
									:onChange="value => onChangeParam({ key: 'lodeUtmCd', value })"
									:disabled="isFlagYn"
								/>
							</td>
						</tr>
						<tr>
							<!-- 비고 -->
							<th>{{ getMessage_('QWCC000906') }}</th>
							<td colspan="5">
								<el-input
									:value="popupData.rmk"
									@input="value => onChangeParam({ key: 'rmk', value })"
									:readonly="isFlagYn"
									maxlength="66"
								/>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<!-- 기본정보 Form 종료 -->

			<!-- 교정정보 Form 시작 -->
			<div class="sf-card__header mt-5">
				<div class="d-flex align-items-end">
					<!-- 교정정보 -->
					<span class="title"><i class="sf-icon icon-sf-caret-right" />{{ getMessage_('QWCC001344') }}</span>
				</div>
			</div>

			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
							<!-- 교정결과(입력,수정불가) -->
							<th class="col-1">{{ getMessage_('QWCC001345') }}</th>
							<td class="col-1">
								<sf-select-group
									labelPosition="left"
									:inputValue="popupData.calRsltCd"
									:options="calRsltCdList"
									:onChange="value => onChangeParam({ key: 'calRsltCd', value })"
									disabled
								/>
							</td>
							<!-- 성적서번호(입력,수정불가) -->
							<th class="col-1">{{ getMessage_('QWCC001348') }}</th>
							<td class="col-1">
								<el-input :value="popupData.rslrNo" @input="value => onChangeParam({ key: 'rslrNo', value })" maxlength="20" readonly />
							</td>
							<!-- 교정상태(입력,수정불가) -->
							<th class="col-1">{{ getMessage_('QWCC001316') }}</th>
							<td class="col-1">
								<sf-select-group
									labelPosition="left"
									:inputValue="popupData.calStCd"
									:options="calStCdList"
									:onChange="value => onChangeParam({ key: 'calStCd', value })"
									disabled
								/>
							</td>
							<!-- 가동상태 -->
							<th class="col-1">{{ getMessage_('QWCC001315') }}</th>
							<td class="col-1">
								<sf-select-group
									labelPosition="left"
									:inputValue="popupData.runStCd"
									:options="runStCdList"
									:onChange="value => onChangeParam({ key: 'runStCd', value })"
									:disabled="isAdminOnly"
								/>
							</td>
						</tr>
						<tr>
							<!-- 교정완료일(입력,수정불가) -->
							<th class="col-1">{{ getMessage_('QWCC001647') }}</th>
							<td class="col-1">
								<el-date-picker
									type="date"
									:value="popupData.calCmplDd?.replaceAll('-', '')"
									@input="value => onChangeParam({ key: 'calCmplDd', value })"
									readonly
									format="yyyy-MM-dd"
									value-format="yyyyMMdd"
								/>
							</td>
							<!-- 교정비용(입력,수정불가) -->
							<th class="col-1">{{ getMessage_('QWCC001347') }}</th>
							<td class="col-1">
								<el-input
									:value="Number(popupData.calExp)"
									@input="value => inputAmt({ key: 'calExp', value })"
									style="text-align: right"
								/>
							</td>

							<!-- 차기교정일 (관리자 전용)-->
							<th class="col-1">{{ !eqipKndDisabled_ ? '* ' : '' }}{{ getMessage_('QWCC001324') }}</th>
							<td class="col-1">
								<el-date-picker
									:value="popupData.nextCalDd?.replaceAll('-', '')"
									@input="value => onChangeParam({ key: 'nextCalDd', value })"
									type="date"
									format="yyyy-MM-dd"
									value-format="yyyyMMdd"
									:disabled="eqipKndDisabled_ || isAdminOnly"
								/>
							</td>
							<!-- 교정장소 -->
							<th class="col-1">{{ getMessage_('QWCC002014') }}</th>
							<td class="col-1">
								<sf-select-group
									labelPosition="left"
									:inputValue="popupData.calWayCd"
									:options="calWayCdList"
									:onChange="value => onChangeParam({ key: 'calWayCd', value })"
									:disabled="isFlagYn"
								/>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<!-- 교정정보 Form 종료 -->
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@qms/mmc/mmcm/MesInfo/store/helpers';
import ActionButtons from './MesInfoBasicFormBtn.vue';

export default {
	props: { scrId: { type: String, default: '' } },
	components: { ActionButtons },
	methods: {
		...rootMethods,
		...serviceMethods,
		onChangeParam({ key, value }) {
			if (key == 'puchDd') {
				//도입일자가 교정일보다 앞설 때 에러
				if (this.popupData.calCmplDd && Number(value) > Number(this.popupData.calCmplDd?.replaceAll('-', ''))) {
					const errMsg = this.$sf_formatString(this.getMessage_('QWCC001400'), [
						this.getMessage_('QWCC001322'),
						this.getMessage_('QWCC001346')
					]);
					this.$sf_toast({ type: 'error', message: errMsg });
					value = '';
				}
			}

			this.onChangeParam_({ key, value });

			//key 가 [calCyclCd 교정주기]일 경우 아래 스크립트로 이벤트를 태운다.
			if (key == 'eqipKndCd') {
				if (value == 'S') {
					this.onChangeParam_({ key: 'nextCalDd', value: '' });
					this.onChangeParam_({ key: 'calCyclCd', value: '' });
				}
			}

			if (key == 'calCyclCd' || key == 'puchDd') {
				if (this.popupData.calCyclCd) {
					//교정일이 있으면 => 교정일 기점, 교정일이 없으면 => 도입일 기점
					const targetMonth = this.popupData.calCmplDd ? this.popupData.calCmplDd : this.popupData.puchDd;
					if (targetMonth) {
						const addMonth = this.popupData.calCyclCd.substring(2);
						const calculated = this.$moment(targetMonth).add(addMonth, 'M').format('YYYYMMDD');
						this.onChangeParam_({ key: 'nextCalDd', value: calculated });
					}
				}
			}
		},
		input({ key, value }) {
			//숫자 길이 7자리, 소수점 3자리로 입력 제한
			value = value.replace(/[^-\.0-9]/g, '');
			const arr = value.toString().split('.');
			if (arr.length > 2) {
				return;
			}
			if (arr.length == 1) {
				if (value.length > 7) {
					value = value.slice(0, 7);
				}
			}
			if (arr.length == 2) {
				if (arr[1].length > 3) {
					arr[1] = arr[1].slice(0, 3);
				}
				if (arr[0].length > 7) {
					arr[0] = arr[0].slice(0, 7);
				}
				arr[1] = '.' + arr[1];
				value = arr.reduce((a, b) => a + b);
			}
			this.onChangeParam_({ key, value });
		},
		inputAmt({ key, value }) {
			//숫자 길이 16자리, 소수점 2자리로 입력 제한
			value = value.replace(/[^-\.0-9]/g, '');
			const arr = value.toString().split('.');
			if (arr.length > 2) {
				return;
			}
			if (arr.length == 1) {
				if (value.length > 16) {
					value = value.slice(0, 16);
				}
			}
			if (arr.length == 2) {
				if (arr[1].length > 2) {
					arr[1] = arr[1].slice(0, 2);
				}
				if (arr[0].length > 16) {
					arr[0] = arr[0].slice(0, 16);
				}
				arr[1] = '.' + arr[1];
				value = arr.reduce((a, b) => a + b);
			}
			this.onChangeParam_({ key, value });
		},
		openUbiReport(param) {
			this.$emit('openUbiReport', param);
		},
		// 유저 관련
		onUserInPutKeyDown(userVal) {
			if (userVal === 'user1') {
				this.onChangeParam_({ key: 'user1Id', value: '' });
				this.onChangeParam_({ key: 'useDeptCd', value: '' });
				this.onChangeParam_({ key: 'useDeptNm', value: '' });
			} else if (userVal === 'user2') {
				this.onChangeParam_({ key: 'user2Id', value: '' });
			}
		},
		onUserSearchPopup(userVal) {
			let sendParams = {};
			if (userVal === 'user1') {
				sendParams = {
					userName: this.popupData.user1Nm,
					userGbn: userVal
				};
			} else if (userVal === 'user2') {
				sendParams = {
					userName: this.popupData.user2Nm,
					userGbn: userVal
				};
			}
			this.$emit('PopupOpen', sendParams);
		},
		// 부서 팝업 관련
		onDeptInPutKeyDown() {
			this.onChangeParam_({ key: 'useDeptCd', value: '' });
		},
		onDeptSearchPopup() {
			this.$emit('PopupOpen', 'dept');
		},
		close() {
			this.$emit('ClosePopup', 'close');
		}
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		isAdminOnly() {
			if (this.isMmcAdmin) return false;
			return true;
		},
		isFlagYn() {
			if (this.isMmcAdmin) return false;
			if (!this.isMmcUser && !this.isMmcAdmin) return true;
			const calStCd = this.popupData.calStCd;
			return calStCd && calStCd !== 'NR' ? true : false;
		}
	}
};
</script>
